import { render } from "./asset-transfer.vue?vue&type=template&id=415fb980&scoped=true"
import script from "./asset-transfer.vue?vue&type=script&lang=js"
export * from "./asset-transfer.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-415fb980"

export default script